/**
 * Created by sunjinyu on 2018/11/16.
 */
import LoadingComponent from './loading.vue'

let Loading = {};

Loading.install = (Vue) => {
  Vue.component('loading', LoadingComponent)
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js